import { Api, apiMixin, ConfigHelper, createApiService } from 'relapp-api';
import store from '@/store/index.js';

const routes = ConfigHelper.entityApiRoutes('users');

export default {
    ...createApiService('users'),

    /**
     * Give access to the customer.
     *
     * @param {object} customer
     *
     * @return {Promise}
     */
    giveAccess(customer) {
        const url = ConfigHelper.apiUrl('customers.give-access', [
            {
                key: '{customer}',
                value: customer.id
            }
        ]);

        return Api.post(url);
    },

    /**
     * Call get all roles endpoint.
     *
     * @return {Promise}
     */
    getRoles() {
        let route = routes['roles.get'];

        return Api.get(route)
            .then(response => {
                store.dispatch('users/updateRoles', response.data.data);

                return response;
            })
            .catch(apiMixin.methods.handleError);
    },

    /**
     * Call get current user endpoint.
     *
     * @return {Promise}
     */
    currentUser() {
        let route = routes['current-user'];

        return Api.get(route)
            .then(response => {
                store.dispatch('user/setUser', response.data.data);

                return response;
            })
            .catch(error => Promise.reject(error));
    }
};
